// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__33dV2","name":"Header_name__1wMkJ","birthday":"Header_birthday__WiH0Z","skeleton":"Header_skeleton__3-Q_G"};